import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../core/form/Button';

class ImportCsvDialogUploadScene extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    onUpload: PropTypes.func,
  };

  handleChange = () => {
    this.props.onChange('csvFile', this.fileInput.files[0]);
    this.props.onUpload();
  };

  render() {
    return (
      <div
        style={{
          flex: 1,
          display: 'flex',
          height: '300px',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Button
          label="Upload file .csv"
          disabled={false}
          size="lg"
          onClick={() => this.fileInput.click()}
          icon="upload"
        />
        <input
          type="file"
          style={{
            visibility: 'hidden',
            width: 0,
            height: 0,
          }}
          value={''}
          onChange={this.handleChange}
          ref={input => (this.fileInput = input)}
          accept=".csv"
        />
      </div>
    );
  }
}

export default ImportCsvDialogUploadScene;
